export const THEME_SETTINGS = Object.freeze({
  LOGO_HTML: process.env.VUE_APP_LOGO_HTML,
  // light
  LIGHT_PRIMARY: `#${process.env.VUE_APP_THEME_LIGHT_PRIMARY}` || '#00274C',
  LIGHT_SECONDARY: `#${process.env.VUE_APP_THEME_LIGHT_SECONDARY}` || '#FFC400',
  LIGHT_POP: `#${process.env.VUE_APP_THEME_LIGHT_POP}` || '#0174BB',
  LIGHT_ACCENT: `#${process.env.VUE_APP_THEME_LIGHT_ACCENT}` || '#989c97',
  LIGHT_ERROR: `#${process.env.VUE_APP_THEME_LIGHT_ERROR}` || '#9A3324',
  LIGHT_TEXT_FONT: `#${process.env.VUE_APP_THEME_LIGHT_TEXT}` || '#000000',
  LIGHT_TEXT_FONT_INVERTED: `#${process.env.VUE_APP_THEME_DARK_TEXT}` || '#FFFFFF',
  // dark
  DARK_PRIMARY: `#${process.env.VUE_APP_THEME_DARK_PRIMARY}` || '#2e2e2e',
  DARK_SECONDARY: `#${process.env.VUE_APP_THEME_DARK_SECONDARY}` || '#8a8a8a',
  DARK_POP: `#${process.env.VUE_APP_THEME_DARK_POP}` || '#0174BB',
  DARK_ACCENT: `#${process.env.VUE_APP_THEME_DARK_ACCENT}` || '#989c97',
  DARK_ERROR: `#${process.env.VUE_APP_THEME_DARK_ERROR}` || '#9A3324',
  DARK_TEXT_FONT: `#${process.env.VUE_APP_THEME_DARK_TEXT}` || '#FFFFFF',
  DARK_TEXT_FONT_INVERTED: `#${process.env.VUE_APP_THEME_LIGHT_TEXT}` || '#000000'
})
